<template>
  <v-card class="card text-body-1 pl-0 py-4" color="neutral1" outlined>
    <div class="d-flex align-center fill-width">
      <v-sheet
        class="mr-2 rounded-l-0 rounded-r-lg"
        :color="raffle.status === 'open' ? 'primary' : 'secondary'"
        width="0.375rem"
        height="5rem"
      ></v-sheet>

      <div class="d-flex flex-column fill-width">
        <div class="d-flex align-center fill-width">
          <div class="text-body-2 font-weight-bold neutral8--text">
            Concurso #{{ raffle.code }}
          </div>

          <v-spacer />

          <div v-if="raffle.status === 'finished'">
            <v-chip
              class="pulse font-weight-bold"
              :color="raffle.winner ? 'yellow accent-3' : 'blue'"
              :class="{ 'neutral--text': raffle.winner }"
              small
              label
            >
              {{ raffle.winner ? "PREMIADA" : " ACUMULOU!" }}

              <v-icon v-if="raffle.winner" color="black" right small>
                fas fa-trophy
              </v-icon>
            </v-chip>
          </div>

          <div v-else-if="raffle.status === 'open'">
            <div class="text1--text">
              Sorteio
              <span class="primary neutral--text font-weight-bold px-2"
                >HOJE</span
              >
            </div>
          </div>
        </div>

        <div class="raffle-title text-uppercase font-weight-bold">
          {{ raffle.name }}
        </div>

        <div>
          <span class="text-h5 font-weight-black primary--text">
            R$ {{ currencyMask(raffle.awards?.cash) }}
          </span>
        </div>
      </div>
    </div>

    <section v-if="!hideFooter" class="pl-4 mt-2">
      <div v-if="raffle.status === 'open'">
        <div class="text1--text mb-2">
          {{ raffle.progress?.purchased }} / {{ raffle.progress?.total }} de
          cotas vendidas
        </div>

        <div v-if="raffle.timeRemaining" class="neutral8--text">
          <div v-if="raffle.timeRemaining === '00:00:00'">
            Sorteio em apuracão, o resultado sai em instantes!
          </div>

          <div v-else>
            Tempo restante:
            <span class="font-weight-bold text1--text">
              {{ raffle.timeRemaining }}
            </span>
          </div>
        </div>
      </div>

      <div v-else-if="raffle.status === 'finished'">
        <div v-if="raffle.status === 'finished'" class="text1--text">
          Número premiado:
          <span class="font-weight-black accent--text text-h6">
            {{ formatResult(raffle.result) }}
          </span>
        </div>

        <div class="neutral8--text">
          Sorteio realizado no dia
          <span class="font-weight-bold text1--text">
            {{
              formatTimezoneDate(
                raffle.finishedAt,
                "D [de] MMM [de] YYYY [às] HH[h]mm"
              )
            }}
          </span>
        </div>
      </div>

      <div class="text-caption text-center neutral6--text mb-n2 mt-3">
        Clique para ver detalhes
      </div>
    </section>
  </v-card>
</template>

<script>
import { currencyMask, formatTimezoneDate, formatResult } from "@/helpers";

export default {
  name: "RaffleCard",

  props: {
    raffle: {
      type: Object,
      required: true,
    },

    hideFooter: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    currencyMask,

    formatTimezoneDate,

    formatResult,
  },
};
</script>

<style src="./style.scss" lang="scss" scoped />
